import 'slick-carousel-latest';

export function initGallerySlider({selector}) {
    $(selector).each((i, el) => {
        initGallerySliderEntity({el});
    });
}

export function initGallerySliderEntity({el}) {
    const $el = $(el);
    const $slider = $el.find('[data-slider]');

    $slider.slick({
        dots: true,
        arrows: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        prevArrow: '<button class="slick-prev" type="button"><svg viewBox="0 0 476.213 476.213" fill="currentColor"><polygon xmlns="http://www.w3.org/2000/svg" points="476.213,223.106 57.426,223.106 91.819,188.713 70.606,167.5 0,238.106 70.606,308.713 91.819,287.5   57.426,253.106 476.213,253.106 "/></svg></button>',
        nextArrow: '<button class="slick-next" type="button"><svg viewBox="0 0 476.213 476.213" fill="currentColor"><polygon points="405.606,167.5 384.394,188.713 418.787,223.106 0,223.106 0,253.106 418.787,253.106 384.394,287.5 405.606,308.713 476.213,238.106 "/></svg></button>',
    });
}
